import { styled } from 'baseui'
import type { Theme } from 'baseui'
import type { ChipTone } from './useClientTabStatusChips'

const chipColors = ($theme: Theme, $tone: ChipTone) => {
  if ($tone === 'ok') {
    return { color: $theme.colors.chipOkText, backgroundColor: $theme.colors.chipOkBg, borderColor: 'transparent' }
  }
  if ($tone === 'warn') {
    return {
      color: $theme.colors.chipWarnText,
      backgroundColor: $theme.colors.chipWarnBg,
      borderColor: $theme.colors.chipWarnBorder,
    }
  }
  return {
    color: $theme.colors.textPulseChipNeutral,
    backgroundColor: $theme.colors.chipNeutralBg,
    borderColor: 'transparent',
  }
}

export const StatusChipsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '6px',
  marginTop: '14px',
})

export const StatusChipButton = styled<'button', { $tone: ChipTone }>('button', ({ $theme, $tone }) => {
  const { color, backgroundColor, borderColor } = chipColors($theme, $tone)

  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    height: '30px',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '10px',
    paddingRight: '12px',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopLeftRadius: '9999px',
    borderTopRightRadius: '9999px',
    borderBottomLeftRadius: '9999px',
    borderBottomRightRadius: '9999px',
    backgroundColor,
    color,
    fontFamily: 'inherit',
    fontSize: '12.5px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }
})

export const NeutralRing = styled('span', {
  width: '10px',
  height: '10px',
  boxSizing: 'border-box',
  borderTopWidth: '1.5px',
  borderBottomWidth: '1.5px',
  borderLeftWidth: '1.5px',
  borderRightWidth: '1.5px',
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  borderRightStyle: 'solid',
  borderTopColor: 'currentColor',
  borderBottomColor: 'currentColor',
  borderLeftColor: 'currentColor',
  borderRightColor: 'currentColor',
  borderTopLeftRadius: '9999px',
  borderTopRightRadius: '9999px',
  borderBottomLeftRadius: '9999px',
  borderBottomRightRadius: '9999px',
})
